     /* On dropdown change */
     $(".product-actions-wrapper select").change(function () {
        console.log("------------------------- BEGIN------------------");
        variantSelection(this);
         //  var optionName = $(this).children('option').attr("data-option");
        // console.log(optionName);
    });
    /* on Page load Get the value of the checked dropdown for all the types
    get the name and value e.g. name = color, value = red */
    var variantCount = 0;
    var variantArray = [];
    var variantOptionArray = {};
    var variantOptionKeys = [];
    var selectedKey = "";
    var selectedVariantID;
    $(
        ".product-actions-wrapper select option:selected"
    ).each(function (index) {
        // console.log("loop through all dropdowns");
       var variantKey =  $(this).parent().parent().children("label").children("h4").html();
        //console.log(variantKey);
        var variantValue = $(this).val();
        /* Adding a map of name to value */
        variantOptionArray[variantKey] = variantValue;
        variantCount++;
        variantOptionKeys.push(variantKey);
        // console.log(variantOptionArray);

        
    });

    setTimeout(loopThroughProductLiquidVariable, 2000);


    function variantSelection(passedElement) {
        // console.log("step1: Calling the variant section when variant is clicked");
        var variantValue = $(passedElement).val();
        var variantKey = $(passedElement).parent().children("label").children("h4").html();
        // console.log(variantValue);
        // console.log(variantKey);
        /* Check if the key exists in the array or not 
      if it exists, then update the key with the new value
      e.g. on load color = red
      but on click  - color = blue
      */
        if (variantKey in variantOptionArray) {
            //  console.log("TRUEEEEEEE KEY EXISTS IN THE ARRAY");
            variantOptionArray[variantKey] = variantValue;
            selectedKey = '';
            if (variantOptionKeys.length == 1) {
                selectedKey = variantOptionArray[variantOptionKeys[0]];
            } else if (variantOptionKeys.length == 2) {
                selectedKey = variantOptionArray[variantOptionKeys[0]] + ' / ' + variantOptionArray[variantOptionKeys[1]];
            } else if (variantOptionKeys.length == 3) {
                selectedKey = variantOptionArray[variantOptionKeys[0]] + ' / ' + variantOptionArray[variantOptionKeys[1]] + ' / ' + variantOptionArray[variantOptionKeys[2]];
            }
            // console.log(selectedKey);
            // if key exists, then don't do anything
        }
        loopThroughProductLiquidVariable();
        // console.log("after checking variantKey in array - show the array  below");
        /* go through each select options and mark it selected */
        // $("#ProductSelect-product-template option").each(function (index) {
        //     var value = $.trim($(this).text());
        //     console.log("value: " + value);
        //     console.log("selectedKey: " + selectedKey);
        //     if (value == selectedKey) {
        //         console.log("found");
        //         $(this).attr('selected', 'selected')
        //         // $(this).parent('select').val(value);
        //         // $(this).parent('select').change();
        //     }
        //     else {
        //         $(this).removeAttr("selected");
        //     }
        // });

       
    }


    function loopThroughProductLiquidVariable() {
        selectedVariantArray = Object.keys(variantOptionArray);
        console.log(selectedVariantArray);
        console.log(selectedVariantArray.length);
        console.log("1" + selectedVariantArray[0]);
        console.log("2" + selectedVariantArray[1]);
        console.log("2" + selectedVariantArray[2]);
        console.log("3" + variantOptionArray[selectedVariantArray[0]]);
        console.log("4" + variantOptionArray[selectedVariantArray[1]]);
        console.log("5" + variantOptionArray[selectedVariantArray[2]]);
        /* get the variant ID */
          console.log(prodLib);
        $.each(prodLib, function (key, value) {
          if (selectedVariantArray.length == 1 && variantOptionArray[selectedVariantArray[0]] == value.option1) {
            console.log("case 1");
            console.log(value.id);
            selectedVariantID = value.id;
            $(".js-add-to-cart-btn").removeClass("hide");
          }
          if (selectedVariantArray.length == 2 && variantOptionArray[selectedVariantArray[0]] == value.option1 && variantOptionArray[selectedVariantArray[1]] == value.option2) {
            console.log("case 2");
            console.log(value.id);
            selectedVariantID = value.id;
            $(".js-add-to-cart-btn").removeClass("hide");
          }
          if (selectedVariantArray.length == 3 && variantOptionArray[selectedVariantArray[0]] == value.option1 && variantOptionArray[selectedVariantArray[1]] == value.option2 && variantOptionArray[selectedVariantArray[2]] == value.option3) {
            console.log("case 3");
            console.log(value.id);
            selectedVariantID = value.id;
            $(".js-add-to-cart-btn").removeClass("hide");
          }
        });
      }

/* Add items to cart */



$('.js-add-to-cart-btn').click(function () {
    let cartSuccess = false;
    var quantity = parseInt($('.js-quantity-selector').val());
    // console.log(selectedVariantID);
    // console.log(quantity);
    if(prodLib.length == 0)
    {
      selectedVariantID = $('.js-add-to-cart-btn').attr('data-attr-itemid');
      // console.log("selectedVariantID: when NULL: " + selectedVariantID)
    }
    CartJS.addItem(selectedVariantID, quantity, {}, {
      "success": function (response, textStatus, jqXHR) {
        // CartJS.getNote();
        // console.log(response);
        // console.log(CartJS.cart);
        cartSuccess=true;
        setTimeout(getCartItemObject, 2000);
        /* Show message */
        $('#cart-message').addClass('message-success');
        $('#cart-message').removeClass('message-error');
        $('#cart-message').html('Successfully added to cart!');
        $('#cart-message').show()
        setTimeout(function() { 
            $('#cart-message').hide(); 
        }, 5000); 
        
        //setTimeout($('#cart-message').hide(), 8000);
        
      },
      // Define an error callback to display an error message.
      /* Pending
      Need to add a div to show the error if something went wrong
      */
      "error": function (jqXHR, textStatus, errorThrown) {
        console.log("Something went wrong");
        $('#cart-message').removeClass('message-success');
        $('#cart-message').addClass('message-error');
        $('#cart-message').html('There was a problem adding to the cart!');
        $('#cart-message').show()
        setTimeout(function() { 
            $('#cart-message').hide(); 
        }, 5000); 
      }
    });

    /* Pass the object after 2 seconds */
    function getCartItemObject()
    {
      if(cartSuccess){
        console.log(CartJS.cart.items);
        console.log(CartJS.cart.item_count);
        console.log(CartJS.cart);
  
          /* if cart items are > 0 then show the mini cart */
           if (CartJS.cart.item_count > 0) {
             $(".cart-box").show();
           }
           $('header').addClass('dark-header-bg');
           reloadAjaxCartItems(CartJS.cart);
      }
    }
   
    
        
  });
